export const DEBUG_COMMANDS = {
  time: {
    title: '📅 TIME MANAGEMENT',
    commands: [
      { command: 'debug.time.setSpeed(1-4)', description: 'Set game speed by slot (1=slowest, 4=fastest)' },
      { command: 'debug.time.pause()', description: 'Pause the game' },
      { command: 'debug.time.resume()', description: 'Resume the game' },
      { command: 'debug.time.jumpTo(d,m,y)', description: 'Jump to specific date' },
      { command: 'debug.time.advanceDays(n)', description: 'Skip forward n days' },
      { command: 'debug.time.getDate()', description: 'Get current date' }
    ]
  },
  company: {
    title: '💼 COMPANY OPERATIONS',
    commands: [
      { command: 'debug.company.setCash(n)', description: 'Set cash amount' },
      { command: 'debug.company.addCash(n)', description: 'Add to cash' },
      { command: 'debug.company.setReputation(0-100)', description: 'Set reputation' },
      { command: 'debug.company.setMarketShare(0-1)', description: 'Set market share' },
      { command: 'debug.company.setResearchPoints(n)', description: 'Set research points' },
      { command: 'debug.company.resetBankruptcy()', description: 'Clear bankruptcy warnings' },
      { command: 'debug.company.maxAll()', description: 'Max out all resources' },
      { command: 'debug.company.getStats()', description: 'View company stats' }
    ]
  },
  buildings: {
    title: '🏢 BUILDING MANAGEMENT',
    commands: [
      { command: 'await debug.buildings.list()', description: 'List all owned buildings' },
      { command: 'await debug.buildings.available()', description: 'List available buildings' },
      { command: 'debug.buildings.buy(buildingId)', description: 'Purchase building (bypasses requirements)' },
      { command: 'await debug.buildings.capacity()', description: 'View capacity breakdown' },
      { command: 'debug.buildings.unlock(buildingId)', description: 'Unlocks building instantly' },
      { command: 'debug.buildings.unlockAll()', description: 'Purchase all buildings instantly' },
      { command: 'debug.buildings.complete()', description: 'Complete all construction instantly' }
    ]
  },
  products: {
    title: '📱 PRODUCT MANAGEMENT',
    commands: [
      { command: 'await debug.products.list()', description: 'List all products' },
      { command: 'debug.products.skipPhase(id)', description: 'Skip to next phase' },
      { command: 'debug.products.instantRelease(id)', description: 'Release immediately' },
      { command: 'debug.products.setSales(id,n)', description: 'Set sales data' },
      { command: 'debug.products.discontinue(id)', description: 'Discontinue product' },
      { command: 'await debug.products.details(id)', description: 'Show product details' }
    ]
  },
  sales: {
    title: '📊 SALES & METRICS',
    commands: [
      { command: 'await debug.sales.summary()', description: 'View sales summary for all products' },
      { command: 'await debug.sales.details(productId)', description: 'Detailed sales breakdown' },
      { command: 'await debug.sales.breakdown(productId)', description: 'Show full sales calculation with all factors' },
      { command: 'debug.sales.setSales(productId, units)', description: 'Set sales numbers' },
      { command: 'await debug.sales.history()', description: 'View current day/month/year sales totals' },
      { command: 'await debug.sales.forecast(productId)', description: 'Forecast future sales (7/30/90 days)' }
    ]
  },
  inventory: {
    title: '📦 INVENTORY MANAGEMENT',
    commands: [
      { command: 'await debug.inventory.components()', description: 'List component inventory' },
      { command: 'debug.inventory.set(componentId, qty)', description: 'Set component inventory quantity' },
      { command: 'debug.inventory.add(componentId, qty)', description: 'Add to component inventory' },
      { command: 'debug.inventory.order(componentId, qty)', description: 'Create instant free order' },
      { command: 'debug.inventory.fillExistingComponents()', description: 'Fill existing components to max (existing only)' },
      { command: 'debug.inventory.fillExistingComponentsTo(amount)', description: 'Fill existing components to amount (existing only)' },
      { command: 'debug.inventory.fillAllComponents()', description: 'Fill all catalog components to max (all components)' },
      { command: 'debug.inventory.fillAllComponentsTo(amount)', description: 'Fill all catalog components to amount (all components)' },
      { command: 'await debug.inventory.devices.list()', description: 'List all products with device inventory' },
      { command: 'await debug.inventory.devices.add(productId, qty)', description: 'Add to device inventory' },
      { command: 'await debug.inventory.devices.set(productId, qty)', description: 'Set device inventory quantity' }
    ]
  },
  research: {
    title: '🔬 RESEARCH',
    commands: [
      { command: 'debug.research.unlockAll()', description: 'Unlock all research' },
      { command: 'debug.research.unlock(id)', description: 'Unlock specific node' },
      { command: 'debug.research.addPoints(n)', description: 'Add research points' },
      { command: 'debug.research.showTree()', description: 'Display research tree' },
      { command: 'debug.research.listUnlocked()', description: 'Show unlocked nodes' },
      { command: 'debug.research.listActive()', description: 'Show active research' }
    ]
  },
  employees: {
    title: '👥 EMPLOYEE MANAGEMENT',
    commands: [
      { command: 'debug.employees.list()', description: 'Show all employees and hiring status' },
      { command: 'debug.employees.hire(role, count)', description: 'Hire employees (e.g. "engineer", 3)' },
      { command: 'debug.employees.fire(role, count)', description: 'Fire employees (e.g. "designer", 2)' },
      { command: 'debug.employees.setRole(role, n)', description: 'Set exact role count' },
      { command: 'debug.employees.payroll()', description: 'View detailed payroll breakdown' },
      { command: 'debug.employees.stats()', description: 'Show all employee details in table' },
      { command: 'debug.employees.hireAll()', description: 'Hire 5 of each role instantly' },
      { command: 'debug.employees.fireAll()', description: 'Fire all employees and cancel hiring' },
      { command: 'debug.employees.add(role, count)', description: 'Instantly add employees (e.g. "engineer", 3)' },
      { command: 'debug.employees.addAll()', description: 'Instantly add 5 of each role' }
    ]
  },
  competitors: {
    title: '🏢 COMPETITORS',
    commands: [
      { command: 'await debug.competitors.list()', description: 'List all companies' },
      { command: 'await debug.competitors.inspect(id)', description: 'View company details' },
      { command: 'await debug.competitors.products(id)', description: 'Show company products' },
      { command: 'await debug.competitors.metrics()', description: 'Market share breakdown' },
      { command: 'await debug.competitors.simulateLaunch(id)', description: 'Force product launch' },
      { command: 'await debug.competitors.internals(id)', description: 'View internal stats & strategy' },
      { command: 'await debug.competitors.inspectAll()', description: 'Debug all active competitors' },
      { command: 'await debug.competitors.getStats(id)', description: 'Get competitor stats as object' },
      { command: 'debug.competitors.nextReleases()', description: 'Show next 5 product releases' }
    ]
  },
  state: {
    title: '🔧 STATE & SETTINGS',
    commands: [
      { command: 'debug.state.export()', description: 'Export game state' },
      { command: 'debug.state.import(state)', description: 'Import game state' },
      { command: 'debug.state.inspect()', description: 'View current state' },
      { command: 'debug.state.history()', description: 'Show event history' },
      { command: 'debug.state.clear()', description: 'Clear console' }
    ]
  },
  settings: {
    title: '⚙️ DEV MODE SETTINGS',
    commands: [
      { command: 'debug.settings.enableAutoProgression()', description: 'Enable auto phase progression' },
      { command: 'debug.settings.disableAutoProgression()', description: 'Disable auto phase progression' },
      { command: 'debug.settings.enableWarnings()', description: 'Enable termination warnings' },
      { command: 'debug.settings.disableWarnings()', description: 'Disable termination warnings' },
      { command: 'debug.settings.prefillNames()', description: 'Enable name prefilling' },
      { command: 'debug.settings.clearNames()', description: 'Disable name prefilling' }
    ]
  }
};

export const getDebugHelpText = () => {
  const sections = Object.values(DEBUG_COMMANDS).map(section => {
    const commandList = section.commands
      .map(cmd => `  ${cmd.command.padEnd(50)} // ${cmd.description}`)
      .join('\n');
    return `${section.title}\n${commandList}`;
  }).join('\n\n');

  return `🎮 Smartphone Simulator Debug Console
=====================================

Available commands are organized by category:

${sections}

📌 NOTES:
- Valid employee roles: engineer, designer, marketer, manager, researcher, tester, assemblyWorker
- Use await for async commands (products, competitors, sales, inventory, buildings)
- Company IDs for competitors: apple, samsung, google, lg, nokia, palm, motorola, microsoft, rim, [oneplus, xiaomi, oppo, vivo]

Type debug.help() to see this message again.`;
};
